import { render, staticRenderFns } from "./SisImportTranslationsModal.vue?vue&type=template&id=180f6e9a&"
import script from "./SisImportTranslationsModal.vue?vue&type=script&lang=js&"
export * from "./SisImportTranslationsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCombobox,VSimpleTable})
